// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ccdSlideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* ══════════════════════════════════════════
   FORM SIDE (left column)
   ══════════════════════════════════════════ */
.ccd-form-side {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  height: 100%;
  background: #fff;
}

.ccd-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(135deg, rgba(255, 251, 235, 0.96), rgba(255, 255, 255, 0.92));
  flex-shrink: 0;
}

.ccd-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.025em;
  line-height: 1.25;
  margin: 0;
}

.ccd-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  width: 36px;
  height: 36px;
  color: #64748b;
  flex-shrink: 0;
  transition: background-color 0.2s;
}
.ccd-close-btn:hover {
  background: #f1f5f9;
}

/* Body */
.ccd-body {
  flex: 1;
  overflow-y: auto;
  padding: 8px 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 18px;
}

/* Section wrapper */
.ccd-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ccd-section-label {
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

/* ── ORDER OPTION cards ── */
.ccd-option-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.ccd-option-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 10px;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  font-size: 0.813rem;
  font-weight: 500;
  color: #6b7280;
  transition:
    border-color 0.15s,
    color 0.15s,
    background 0.15s;
}

.ccd-option-card:hover {
  border-color: #bfdbfe;
  color: #1d4ed8;
  background: #f0f7ff;
}

.ccd-option-card--active {
  border-color: #0860e6 !important;
  color: #0860e6 !important;
  background: #f0f7ff !important;
  font-weight: 600;
}

.ccd-option-icon {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  stroke-width: 1.5;
}

/* ── Input fields row — stacked ── */
.ccd-fields-row {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ccd-field-col {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* Customer name overrides */
.customer-name-new {
  background-color: white !important;
}

/* WhatsApp checkbox */
.check-wrapper-box-new {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 2px;
}

.restore-text-new {
  font-size: 0.813rem;
  font-weight: 500;
  color: #6b7280;
}

/* ── Footer ── */
.ccd-footer {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 24px;
  border-top: 1px solid #f0f2f5;
  flex-shrink: 0;
}

.ccd-btn-skip {
  flex: 1;
  height: 48px;
  padding: 10px 16px;
  border: 1px solid var(--surface-black);
  border-radius: 20px;
  background: #fff;
  font-size: 0.875rem;
  font-weight: 500;
  color: #334155;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition:
    background-color 0.2s,
    border-color 0.2s;
  white-space: nowrap;
}
.ccd-btn-skip:hover {
  background-color: #f8fafc;
  border-color: #cbd5e1;
}
.ccd-btn-skip:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ccd-btn-add {
  flex: 1;
  height: 48px;
  padding: 10px 16px;
  border: 1px solid transparent;
  border-radius: 20px;
  background: #3b82f6;
  font-size: 0.875rem;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background-color 0.2s;
}
.ccd-btn-add:hover {
  background-color: #2563eb;
}
.ccd-btn-add:disabled {
  background-color: #93c5fd;
  opacity: 0.5;
  cursor: not-allowed;
}

/* ══════════════════════════════════════════
   INSIGHTS SIDE (right column)
   ══════════════════════════════════════════ */
.ccd-insights-side {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: #f8fafc;
  height: 100%;
  overflow: hidden;
}

.ccd-insights-header {
  padding: 22px 20px 12px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #94a3b8;
  flex-shrink: 0;
}

.ccd-insights-body {
  flex: 1;
  overflow-y: auto;
  padding: 0 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Customer card */
.ccd-insights-customer-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ccd-insights-customer-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.ccd-insights-customer-name {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  line-height: 1.2;
}

.ccd-insights-customer-phone {
  font-size: 0.813rem;
  color: #6b7280;
  margin-top: 2px;
}

.ccd-insights-badge {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 3px 8px;
  border-radius: 999px;
  white-space: nowrap;
  flex-shrink: 0;
  background: #dbeafe;
  color: #1d4ed8;
}

.ccd-insights-badge.new {
  background: #f0fdf4;
  color: #15803d;
  border: 1px solid #bbf7d0;
}

.ccd-insights-order-opt {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding-top: 8px;
  border-top: 1px solid #f0f2f5;
}

.ccd-insights-opt-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
}

.ccd-insights-opt-value {
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
}

/* Stats 2×2 grid */
.ccd-insights-stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.ccd-insights-stat-tile {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ccd-insights-stat-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
}

.ccd-insights-stat-value {
  font-size: 20px;
  font-weight: 800;
  color: #111827;
  line-height: 1.1;
}

/* Last ordered */
.ccd-insights-last-tile {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ccd-insights-last-value {
  font-size: 0.9rem;
  font-weight: 600;
  color: #374151;
}

/* Loader */
.ccd-insights-loader {
  font-size: 0.813rem;
  color: #6b7280;
  text-align: center;
  padding: 12px 0;
  animation: pulse 1.4s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}

.ccd-insights-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
  border: 1px solid #f1f5f9;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  gap: 8px;
}

.ccd-insights-empty-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #eff6ff;
  color: #2a71ff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-bottom: 16px;
}

.ccd-insights-empty-title {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 8px 0;
}

.ccd-insights-empty-sub {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
  max-width: 320px;
}

/* ══════════════════════════════════════════
   DELIVERY ADDRESS SECTION
   ══════════════════════════════════════════ */
.ccd-addr-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ccd-addr-add-btn {
  font-size: 0.8rem;
  font-weight: 600;
  color: #0860e6;
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px 0;
  transition: color 0.12s;
}
.ccd-addr-add-btn:hover {
  color: #0751c4;
}

.ccd-addr-loader {
  font-size: 0.8rem;
  color: #9ca3af;
  padding: 8px 0;
}

.ccd-addr-empty {
  font-size: 0.8rem;
  color: #9ca3af;
  margin: 0;
  padding: 6px 0;
}

/* Saved address cards */
.ccd-addr-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ccd-addr-card {
  padding: 10px 12px;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition:
    border-color 0.12s,
    background 0.12s;
  background: #fff;
}

.ccd-addr-card:hover {
  border-color: #93c5fd;
  background: #f8fbff;
}

.ccd-addr-card--active {
  border-color: #0860e6 !important;
  background: #eff6ff !important;
}

.ccd-addr-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.ccd-addr-type {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #374151;
}

.ccd-addr-selected-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #0860e6;
  flex-shrink: 0;
}

.ccd-addr-line {
  font-size: 0.8rem;
  color: #374151;
  margin: 0;
  line-height: 1.4;
}

.ccd-addr-line--muted {
  color: #9ca3af;
}

/* New address form */
.ccd-addr-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-sizing: border-box;
}

/* ── Delivery address header ── */
.ccd-delivery-address-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px; /* gap-2 */
  font-size: 11px;
  font-weight: 600;
  color: #1e293b; /* text-slate-800 */
  margin-top: 16px; /* mt-4 */
}

.ccd-delivery-address-header-inner {
  display: flex;
  align-items: center;
  gap: 6px; /* gap-1.5 */
}

.ccd-delivery-address-header-icon {
  width: 12px; /* h-3 w-3 */
  height: 12px;
  color: #2a71ff;
  flex-shrink: 0;
}

/* ── Address container section (single card) ── */
.ccd-address-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-sizing: border-box;
  margin-top: 12px;
}

/* ── Address type options ── */
.ccd-addr-type-options {
  display: flex;
  gap: 10px;
  width: 100%;
  margin-bottom: 4px;
}

.ccd-addr-type-option {
  flex: 1;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 8px 12px;
  cursor: pointer;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  transition:
    border-color 0.15s,
    background 0.15s;
}

.ccd-addr-type-option.active {
  border-color: #2a71ff;
  background: rgba(42, 113, 255, 0.06);
}

.ccd-addr-type-label-text {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
}

.ccd-addr-radio {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #cbd5e1;
  background: #ffffff;
  flex-shrink: 0;
  margin-top: 2px;
  transition: all 0.2s ease;
  position: relative;
}

.ccd-addr-radio.active {
  border-color: #2a71ff;
  background: #2a71ff;
}

.ccd-addr-radio.active::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ffffff;
}

/* ── Inputs ── */
.ccd-addr-inputs-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 100%;
}

.ccd-addr-input-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.ccd-addr-input-group--full {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ccd-addr-input-label {
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
  line-height: 1;
}

.ccd-addr-input-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 30px;
  padding: 0 14px;
  height: 44px;
  background: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
  box-sizing: border-box;
  position: relative;
}

.ccd-addr-input-wrap:focus-within {
  border-color: #94a3b8;
  box-shadow: 0 0 0 1px #94a3b8;
}

.ccd-addr-input-wrap svg {
  flex-shrink: 0;
  color: #94a3b8;
  width: 16px;
  height: 16px;
}

.ccd-addr-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
  color: #0f172a;
  background: transparent;
  min-width: 0;
  padding: 0;
  height: 100%;
}

.ccd-addr-input::placeholder {
  color: #94a3b8;
}

.ccd-addr-input--no-icon {
  padding-left: 0;
}

/* hide number input spinners */
.ccd-addr-input[type="number"]::-webkit-inner-spin-button,
.ccd-addr-input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.ccd-addr-input[type="number"] {
  -moz-appearance: textfield;
}

.ccd-addr-error {
  color: #ef4444;
  font-size: 11px;
  font-weight: 500;
  margin-top: 2px;
  margin-bottom: 0px;
}

/* Legacy classes kept for other usages */
.addCusomerText {
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 100%;
  color: var(--surface-g5);
}

.deliveryOptionsRadioButtons {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 3px;
  margin-bottom: 10px;
}

.skip-button-container-new {
  margin-top: 10px;
  display: flex;
  gap: 10px;
}

.ccd-insights-inline-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 8px;
}

.ccd-insights-empty-header-title {
  margin-bottom: 24px;
  text-align: left;
  width: 100%;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #2a71ff;
  margin-top: 0;
}

.ccd-insights-section-title {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #2a71ff;
  margin-top: 8px;
}

.ccd-insights-actions-row {
  margin-top: 24px;
  display: flex;
  gap: 12px;
  width: 100%;
}

/* ── REFERENCE DESIGN STYLES (NO TAILWIND/MUI) ── */

.ccd-ref-container {
  border-radius: 16px;
  border: 1px solid #d1fae5;
  background-color: #ffffff;
  padding: 20px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.ccd-ref-header-row {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.ccd-ref-avatar {
  display: flex;
  height: 48px;
  width: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border: 1px solid #d1fae5;
  background-color: #ecfdf5;
  color: #059669;
}

.ccd-ref-avatar-icon {
  height: 24px;
  width: 24px;
}

.ccd-ref-customer-name {
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  font-size: 1rem;
}

.ccd-ref-customer-phone {
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  margin: 2px 0 0 0;
}

.ccd-ref-stats-grid {
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.ccd-ref-stat-tile {
  border-radius: 16px;
  border: 1px solid #f1f5f9;
  background-color: #f8fafc;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ccd-ref-stat-label {
  margin: 0;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #94a3b8;
}

.ccd-ref-stat-value {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  color: #1e293b;
}

.ccd-ref-stat-value-sm {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 700;
  color: #1e293b;
}

.ccd-ref-stat-tile-pink {
  border-radius: 14px;
  border: 1px solid #fce7f3;
  background-color: #fdf2f8;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ccd-ref-stat-label-pink {
  margin: 0;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #ec4899;
}

.ccd-ref-stat-value-pink {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  color: #be185d;
}

.ccd-ref-pts-label {
  font-size: 0.75rem;
  font-weight: 400;
  color: #db2777;
}

.ccd-ref-select-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  border-radius: 14px;
  font-size: 0.875rem;
  font-weight: 500;
  transition:
    background-color 0.2s,
    border-color 0.2s,
    box-shadow 0.2s;
  border: 1px solid #059669;
  min-height: 36px;
  padding: 8px 16px;
  height: 48px;
  width: 100%;
  background-color: #059669;
  color: #ffffff;
  box-shadow:
    0 4px 6px -1px rgba(16, 185, 129, 0.2),
    0 2px 4px -2px rgba(16, 185, 129, 0.2);
  cursor: pointer;
  outline: none;
}

.ccd-ref-select-btn:hover:not(:disabled) {
  background-color: #047857;
  border-color: #047857;
}

.ccd-ref-select-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ── Delivery Mode Section ── */
.ccd-delivery-section {
  background: #ffffff;
  border: 1px solid #dbeafe; /* border-blue-100 */
  border-radius: 26px; /* rounded-[26px] */
  padding: 16px; /* p-4 */
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin-bottom: 8px;
  margin-top: 8px;
}

.ccd-delivery-section-label {
  font-size: 11px; /* text-[11px] */
  font-weight: 700; /* font-bold */
  color: #94a3b8; /* text-slate-400 */
  letter-spacing: 0.18em; /* tracking-[0.18em] */
  text-transform: uppercase; /* uppercase */
  margin: 0 0 4px;
}

.ccd-delivery-section-desc {
  font-size: 14px; /* text-sm */
  font-weight: 500; /* font-medium */
  color: #475569; /* text-slate-600 */
  margin: 0 0 16px;
}

/* ── Mode options ── */
.ccd-delivery-mode-options {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px; /* gap-3 */
}

@media (max-width: 640px) {
  .ccd-delivery-mode-options {
    grid-template-columns: 1fr;
  }
}

.ccd-delivery-mode-option {
  border: 1px solid #e2e8f0; /* border-slate-200 */
  border-radius: 22px; /* rounded-[22px] */
  padding: 16px; /* px-4 py-4 */
  cursor: pointer;
  background: rgba(248, 250, 252, 0.7); /* bg-slate-50/70 */
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  transition: all 0.2s ease;
  text-align: left;
}

.ccd-delivery-mode-option:hover {
  border-color: #cbd5e1; /* hover:border-slate-300 */
  background: #ffffff; /* hover:bg-white */
}

.ccd-delivery-mode-option.active {
  border-color: #2a71ff; /* border-primary */
  background: rgba(42, 113, 255, 0.06); /* bg-primary/[0.06] */
  box-shadow: 0 10px 30px rgba(42, 113, 255, 0.12); /* shadow-[0_10px_30px_rgba(42,113,255,0.12)] */
}

.ccd-delivery-mode-option-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ccd-delivery-mode-option-title {
  font-size: 14px; /* text-sm */
  font-weight: 600; /* font-semibold */
  color: #0f172a; /* text-slate-900 */
}

.ccd-delivery-mode-option-desc {
  font-size: 12px; /* text-xs */
  color: #64748b; /* text-slate-500 */
  line-height: 1.25rem; /* leading-5 */
}

.ccd-delivery-radio {
  width: 20px; /* h-5 w-5 */
  height: 20px;
  border-radius: 50%;
  border: 2px solid #cbd5e1; /* border-slate-300 */
  background: #ffffff;
  flex-shrink: 0;
  margin-top: 2px; /* mt-0.5 */
  transition: all 0.2s ease;
  position: relative;
}

.ccd-delivery-radio.active {
  border-color: #2a71ff; /* border-primary */
  background: #2a71ff; /* bg-primary */
}

.ccd-delivery-radio.active::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px; /* h-2 w-2 */
  height: 8px;
  border-radius: 50%;
  background: #ffffff; /* bg-white */
}

/* ── Slots Picker ── */
.ccd-delivery-slots-container {
  margin-top: 16px;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  padding: 12px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.ccd-delivery-slots-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #1e293b;
}

.ccd-delivery-slots-clock-icon {
  width: 14px;
  height: 14px;
  color: #2a71ff;
  flex-shrink: 0;
}

/* Date Chips */
.ccd-delivery-date-chips-container {
  margin-top: 12px;
  margin-left: -12px;
  margin-right: -12px;
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  overflow-x: auto;
  scrollbar-width: thin;
  padding-bottom: 8px;
}

.ccd-delivery-date-chips-container::-webkit-scrollbar {
  height: 4px;
}

.ccd-delivery-date-chips-container::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}

.ccd-delivery-date-chips-container::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.ccd-delivery-date-chips-container::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.ccd-delivery-date-chip-btn {
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 9999px;
  border: 1px solid #cbd5e1;
  background-color: #ffffff;
  color: #475569;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}

.ccd-delivery-date-chip-btn:hover {
  border-color: #94a3b8;
  background-color: #f8fafc;
}

.ccd-delivery-date-chip-btn--selected {
  border-color: #2a71ff !important;
  background-color: #2a71ff !important;
  color: #ffffff !important;
  box-shadow:
    0 4px 6px -1px rgba(42, 113, 255, 0.2),
    0 2px 4px -1px rgba(42, 113, 255, 0.2) !important;
}

.ccd-delivery-date-chip-btn--selected:hover {
  background-color: #1e53d0 !important;
  border-color: #1e53d0 !important;
}

/* Slots Grid */
.ccd-delivery-slots-grid {
  margin-top: 8px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 6px;
}

@media (min-width: 640px) {
  .ccd-delivery-slots-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1280px) {
  .ccd-delivery-slots-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.ccd-delivery-slot-btn--selected {
  border-radius: 12px;
  border: 1px solid #2a71ff;
  background-color: #eff6ff;
  color: #2a71ff;
  padding: 8px 10px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-align: left;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
  width: 100%;
  box-shadow: 0 8px 20px rgba(42, 113, 255, 0.1);
}

.ccd-delivery-slot-btn--unselected {
  border-radius: 12px;
  border: 1px solid #cbd5e1;
  background-color: rgba(241, 245, 249, 0.8);
  color: #475569;
  padding: 8px 10px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-align: left;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
  width: 100%;
}

.ccd-delivery-slot-btn--unselected:hover {
  border-color: #94a3b8;
  background-color: #ffffff;
}

.ccd-delivery-slots-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0;
}

.ccd-delivery-slots-spinner {
  width: 24px;
  height: 24px;
  border: 2px solid #e2e8f0;
  border-top-color: #2a71ff;
  border-radius: 50%;
  animation: ccd-delivery-spin 0.7s linear infinite;
  flex-shrink: 0;
}

@keyframes ccd-delivery-spin {
  to {
    transform: rotate(360deg);
  }
}

.ccd-delivery-slots-empty {
  font-size: 14px;
  color: #64748b;
  text-align: center;
  padding: 16px 0;
  margin: 0;
  width: 100%;
  grid-column: span 2;
}

/* ── Saved Addresses Section ── */
.ccd-saved-addresses-section {
  border-radius: 16px;
  border: 1px solid #cbd5e1; /* border-slate-200 */
  background-color: rgba(241, 245, 249, 0.8); /* bg-slate-50/80 */
  padding: 8px; /* p-2 */
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.ccd-saved-addresses-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px; /* mb-2 */
  padding: 0 4px; /* px-1 */
  box-sizing: border-box;
}

.ccd-saved-addresses-title {
  display: block;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #64748b; /* text-slate-500 */
}

.ccd-add-address-link {
  display: inline-flex;
  align-items: center;
  gap: 4px; /* gap-1 */
  font-size: 11px;
  font-weight: 600;
  color: #2a71ff;
  background: none;
  border: none;
  cursor: pointer;
  transition: color 0.2s ease;
  padding: 0;
  font-family: inherit;
}

.ccd-add-address-link:hover:not(:disabled) {
  color: #1c55d0;
}

.ccd-add-address-link:disabled {
  color: #94a3b8;
  cursor: not-allowed;
}

.ccd-saved-addresses-grid {
  display: grid;
  gap: 8px; /* gap-2 */
  padding-bottom: 4px; /* pb-1 */
  width: 100%;
  box-sizing: border-box;
}

.ccd-saved-address-card {
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  border: 1px solid #cbd5e1; /* border-slate-200 */
  padding: 16px; /* p-4 */
  text-align: left;
  background-color: #ffffff;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  box-sizing: border-box;
}

.ccd-saved-address-card:hover {
  border-color: #94a3b8; /* hover:border-slate-300 */
}

.ccd-saved-address-card.active {
  border-color: #2a71ff !important;
  background-color: #ffffff !important;
  box-shadow:
    0 1px 2px 0 rgba(0, 0, 0, 0.05),
    0 0 0 1px rgba(42, 113, 255, 0.2) !important;
}

.ccd-saved-address-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 4px; /* mb-1 */
  box-sizing: border-box;
}

.ccd-saved-address-type-label {
  font-size: 12px;
  font-weight: 700;
  color: #1e293b; /* text-slate-800 */
  letter-spacing: 0.025em; /* tracking-wide */
  text-transform: uppercase;
}

.ccd-edit-address-pen-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8; /* text-slate-400 */
  opacity: 0;
  transition: opacity 0.2s ease;
}

.ccd-saved-address-card:hover .ccd-edit-address-pen-btn {
  opacity: 1;
}

.ccd-saved-address-description {
  font-size: 12px;
  color: #64748b; /* text-slate-500 */
  line-height: 1.625; /* leading-relaxed */
  padding-right: 24px; /* pr-6 */
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* ── Disabled states for Address type options ── */
.ccd-addr-type-option.disabled {
  opacity: 0.5;
  background: #f9fafb;
  cursor: not-allowed;
  pointer-events: none;
}

.ccd-addr-radio.disabled {
  background: #f3f4f6;
  border-color: #e5e7eb;
}

/* ── Visual disabled select/add button state ── */
.ccd-ref-select-btn.visual-disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #9ca3af !important;
  border-color: #9ca3af !important;
  box-shadow: none !important;
}

/* ── Charges Section ── */
.ccd-charges-section {
  box-sizing: border-box;
  margin-top: 12px;
}

/* New Charges Layout */
.ccd-charges-row {
  display: flex;
  align-items: center;
  gap: 12px; /* gap-3 (12px) */
  width: 100%;
  box-sizing: border-box;
}

.ccd-charge-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  box-sizing: border-box;
}

.ccd-charge-label {
  margin-bottom: 6px; /* mb-1.5 (6px) */
  display: block;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #94a3b8; /* text-slate-400 */
}

.ccd-charge-input-wrap {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}

.ccd-charge-currency-prefix {
  display: flex;
  height: 40px; /* h-10 */
  align-items: center;
  justify-content: center;
  border-radius: 12px 0 0 12px; /* rounded-l-xl */
  border: 1px solid #cbd5e1; /* border-slate-200 */
  border-right: 0;
  background-color: #f8fafc; /* bg-slate-50 */
  padding: 0 12px; /* px-3 */
  color: #64748b; /* text-slate-500 */
  font-size: 14px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */
  box-sizing: border-box;
}

.ccd-charge-input {
  display: flex;
  width: 100%;
  height: 40px; /* h-10 */
  border-radius: 0 12px 12px 0; /* rounded-r-xl */
  border: 1px solid #cbd5e1; /* border-slate-200 */
  background-color: #ffffff; /* bg-white */
  padding: 0 12px; /* px-3 */
  font-size: 14px; /* text-sm */
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.ccd-charge-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6, 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.ccd-charge-input::placeholder {
  color: #94a3b8;
}

.ccd-loader-inside-input {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
}

/* ── Edit Address actions ── */
.ccd-edit-address-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  width: 100%;
  margin-top: 16px;
}

.ccd-edit-address-btn-cancel {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  border-radius: 14px;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.2s ease;
  border: 1px solid #cbd5e1;
  height: 48px;
  background-color: #ffffff;
  color: #64748b;
  cursor: pointer;
  outline: none;
}

.ccd-edit-address-btn-cancel:hover:not(:disabled) {
  background-color: #f8fafc;
  color: #334155;
  border-color: #94a3b8;
}

.ccd-edit-address-btn-update {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  border-radius: 14px;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.2s ease;
  border: 1px solid #0860e6;
  height: 48px;
  background-color: #0860e6;
  color: #ffffff;
  box-shadow: 0 4px 6px -1px rgba(8, 96, 230, 0.2);
  cursor: pointer;
  outline: none;
}

.ccd-edit-address-btn-update:hover:not(:disabled) {
  background-color: #0751c4;
  border-color: #0751c4;
}

.ccd-edit-address-btn-update:disabled {
  background-color: #cbd5e1;
  border-color: #cbd5e1;
  color: #94a3b8;
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}

/* ────────────────────────────────────────────────────────
   REFERENCE IMPLEMENTATION STYLES (NO TAILWIND)
   ──────────────────────────────────────────────────────── */

.ccd-header-ref {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f1f5f9; /* border-slate-100 */
  background-color: #ffffff;
  padding: 16px 20px; /* px-5 py-4 */
  flex-shrink: 0;
  box-sizing: border-box;
}

.ccd-title-ref {
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.025em; /* tracking-tight */
  color: #0f172a; /* text-slate-950 */
  margin: 0;
}

.ccd-close-btn-ref {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: transparent;
  border: 1px solid transparent;
  width: 32px; /* h-8 */
  height: 32px; /* w-8 */
  border-radius: 9999px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  color: #64748b; /* text-slate-500 */
  outline: none;
  padding: 0;
}

.ccd-close-btn-ref:hover {
  background-color: #f1f5f9;
}

.ccd-split-grid {
  display: grid;
  flex: 1;
  min-height: 0;
  width: 100%;
}

@media (min-width: 1024px) {
  .ccd-split-grid {
    grid-template-columns: 1.18fr 0.82fr;
  }
}

.ccd-form-side-ref {
  position: relative;
  display: flex;
  height: 100%;
  min-height: 0;
  min-width: 0;
  flex-direction: column;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  box-sizing: border-box;
}

.ccd-form-content-ref {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 16px; /* p-4 */
  overflow: hidden;
  box-sizing: border-box;
  height: 100%;
}

@media (min-width: 1024px) {
  .ccd-form-content-ref {
    padding: 20px; /* lg:p-5 */
  }
}

.ccd-form-scrollable-ref {
  margin-top: 0;
  display: flex;
  min-height: 0;
  flex: 1;
  flex-direction: column;
  gap: 12px; /* gap-3 */
  overflow-y: auto;
  padding-right: 4px; /* pr-1 */
  box-sizing: border-box;
}

.ccd-order-option-section-ref {
  border-radius: 20px;
  border: 1px solid #dbeafe; /* border-blue-100 */
  background-color: #ffffff;
  padding: 8px; /* p-2 */
  box-shadow: 0 16px 36px rgba(42, 113, 255, 0.08); /* shadow-[0_16px_36px_rgba(42,113,255,0.08)] */
  box-sizing: border-box;
}

.ccd-section-label-ref {
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #94a3b8; /* text-slate-400 */
  margin: 0;
}

.ccd-option-grid-ref {
  margin-top: 6px; /* mt-1.5 */
  display: grid;
  gap: 6px; /* gap-1.5 */
}

@media (min-width: 640px) {
  .ccd-option-grid-ref {
    grid-template-columns: repeat(3, 1fr);
  }
}

.ccd-option-card-ref {
  border-radius: 16px;
  border: 1px solid #e2e8f0; /* border-slate-200 */
  padding: 8px 10px; /* px-2.5 py-2 */
  text-align: left;
  transition: all 0.2s ease;
  background-color: rgba(248, 250, 252, 0.8); /* bg-slate-50/80 */
  cursor: pointer;
  outline: none;
  box-sizing: border-box;
}

.ccd-option-card-ref:hover {
  border-color: #cbd5e1; /* hover:border-slate-300 */
  background-color: #ffffff; /* hover:bg-white */
}

.ccd-option-card-ref.active {
  border-color: #2a71ff;
  background-color: #eff6ff; /* bg-blue-50 */
  box-shadow: 0 8px 20px rgba(42, 113, 255, 0.1); /* shadow-[0_8px_20px_rgba(42,113,255,0.10)] */
}

.ccd-option-card-inner-ref {
  display: flex;
  min-height: 60px;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
}

.ccd-option-icon-container-ref {
  display: flex;
  height: 28px; /* h-7 */
  width: 28px; /* w-7 */
  align-items: center;
  justify-content: center;
  border-radius: 8px; /* rounded-lg */
  background-color: #ffffff;
  color: #2a71ff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */
  box-sizing: border-box;
}

.ccd-option-icon-container-ref svg {
  width: 14px; /* h-3.5 */
  height: 14px; /* w-3.5 */
  stroke-width: 2px;
}

.ccd-option-text-ref {
  margin-top: 6px; /* mt-1.5 */
  font-size: 13px;
  font-weight: 600;
  line-height: 1rem; /* leading-4 */
  color: #0f172a; /* text-slate-900 */
  margin-bottom: 0;
}

.ccd-inputs-grid-ref {
  display: grid;
  gap: 12px; /* gap-3 */
  box-sizing: border-box;
}

@media (min-width: 640px) {
  .ccd-inputs-grid-ref {
    grid-template-columns: 1.05fr 1fr;
  }
}

.ccd-input-label-ref {
  margin-bottom: 6px; /* mb-1.5 */
  display: block;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #94a3b8; /* text-slate-400 */
}

.ccd-mobile-input-row-ref {
  display: flex;
  flex-direction: column;
  gap: 8px; /* gap-2 */
  position: relative;
  box-sizing: border-box;
}

@media (min-width: 640px) {
  .ccd-mobile-input-row-ref {
    flex-direction: row;
  }
}

.ccd-footer-ref {
  z-index: 10;
  border-top: 1px solid rgba(226, 232, 240, 0.8); /* border-slate-200/80 */
  background-color: rgba(248, 250, 252, 0.95); /* bg-slate-50/95 */
  padding: 10px 16px; /* px-4 py-2.5 */
  backdrop-filter: blur(4px); /* backdrop-blur-sm */
  box-sizing: border-box;
}

@media (min-width: 1024px) {
  .ccd-footer-ref {
    padding: 10px 20px; /* lg:px-5 */
  }
}

.ccd-footer-inner-ref {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px; /* gap-2.5 */
  box-sizing: border-box;
}

.ccd-btn-skip-ref {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-weight: 500;
  border: 1px solid #cbd5e1; /* border-slate-200 */
  border-radius: 20px; /* rounded-xl */
  background-color: #ffffff;
  padding: 8px 20px; /* px-5 */
  height: 40px; /* h-10 */
  font-size: 14px; /* text-sm */
  color: #334155; /* text-slate-700 */
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06); /* shadow-[0_10px_24px_rgba(15,23,42,0.06)] */
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  outline: none;
  box-sizing: border-box;
}

.ccd-btn-skip-ref:hover {
  background-color: #f8fafc; /* hover:bg-slate-50 */
}

.ccd-btn-skip-ref:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ccd-btn-add-ref {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-weight: 500;
  border: 1px solid transparent;
  border-radius: 20px; /* rounded-xl */
  background-color: #2a71ff;
  color: #ffffff;
  padding: 8px 20px; /* px-5 */
  height: 40px; /* h-10 */
  min-width: 82px; /* min-w-[82px] */
  font-size: 14px; /* text-sm */
  box-shadow: 0 10px 28px rgba(42, 113, 255, 0.24); /* shadow-[0_10px_28px_rgba(42,113,255,0.24)] */
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  outline: none;
  box-sizing: border-box;
}

.ccd-btn-add-ref:hover {
  background-color: #1f63ea; /* hover:bg-[#1f63ea] */
}

.ccd-btn-add-ref:disabled {
  background-color: #e2e8f0; /* disabled:bg-slate-200 */
  color: #94a3b8; /* disabled:text-slate-500 */
  box-shadow: none;
  cursor: not-allowed;
}

.ccd-insights-side-ref {
  display: flex;
  height: 100%;
  min-height: 0;
  min-width: 0;
  flex-direction: column;
  border-left: 1px solid #f1f5f9; /* border-slate-100 */
  background: linear-gradient(180deg, #eff6ff 0%, #ffffff 100%);
  box-sizing: border-box;
}

.ccd-insights-content-ref {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 14px; /* p-3.5 */
  overflow-y: auto;
  box-sizing: border-box;
}

@media (min-width: 1024px) {
  .ccd-insights-content-ref {
    padding: 16px; /* lg:p-4 */
  }
}

.ccd-insights-title-ref {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: #2a71ff;
  margin: 0 0 12px 0; /* mt-3 */
}

.ccd-insights-card-ref {
  border-radius: 22px;
  border: 1px solid #dbeafe; /* border-blue-100 */
  background-color: rgba(255, 255, 255, 0.9); /* bg-white/90 */
  padding: 16px; /* p-4 */
  box-shadow: 0 18px 38px rgba(42, 113, 255, 0.08); /* shadow-[0_18px_38px_rgba(42,113,255,0.08)] */
  margin-bottom: 10px; /* space-y-2.5 */
  box-sizing: border-box;
}

.ccd-insights-card-header-ref {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px; /* gap-3 */
  box-sizing: border-box;
}

.ccd-insights-card-name-ref {
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1;
  color: #0f172a; /* text-slate-950 */
  margin: 0;
}

.ccd-insights-card-mobile-ref {
  margin-top: 4px; /* mt-1 */
  font-size: 13px;
  color: #64748b; /* text-slate-500 */
  margin-bottom: 0;
}

.ccd-insights-card-badge-ref {
  border-radius: 9999px;
  background-color: #eff6ff; /* bg-blue-50 */
  padding: 4px 10px; /* px-2.5 py-1 */
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #2a71ff;
  white-space: nowrap;
}

.ccd-insights-card-option-ref {
  margin-top: 12px; /* mt-3 */
  border-radius: 18px;
  border: 1px solid #f1f5f9; /* border-slate-100 */
  background-color: #f8fafc; /* bg-slate-50 */
  padding: 10px 12px; /* px-3 py-2.5 */
  box-sizing: border-box;
}

.ccd-insights-card-option-label-ref {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #94a3b8; /* text-slate-400 */
  margin: 0;
}

.ccd-insights-card-option-val-ref {
  margin-top: 6px; /* mt-1.5 */
  font-size: 13px;
  font-weight: 600;
  color: #0f172a; /* text-slate-900 */
  margin-bottom: 0;
}

.ccd-insights-grid-ref {
  display: grid;
  gap: 8px; /* gap-2 */
  margin-bottom: 10px; /* space-y-2.5 */
  box-sizing: border-box;
}

@media (min-width: 640px) {
  .ccd-insights-grid-ref {
    grid-template-columns: repeat(2, 1fr);
  }
}

.ccd-insights-tile-ref {
  border-radius: 18px;
  border: 1px solid #ffffff;
  background-color: #ffffff;
  padding: 12px; /* p-3 */
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.06); /* shadow-[0_14px_28px_rgba(15,23,42,0.06)] */
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
}

.ccd-insights-tile-label-ref {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #94a3b8; /* text-slate-400 */
  margin: 0;
}

.ccd-insights-tile-val-ref {
  margin-top: 6px; /* mt-1.5 */
  font-size: 1.9rem;
  font-weight: 700;
  line-height: 1;
  color: #0f172a; /* text-slate-950 */
  margin-bottom: 0;
  display: flex;
  align-items: center;
  gap: 6px; /* gap-1.5 */
}

.ccd-insights-last-ref {
  border-radius: 20px;
  border: 1px solid #e2e8f0; /* border-slate-200 */
  background-color: rgba(255, 255, 255, 0.9); /* bg-white/90 */
  padding: 16px; /* p-4 */
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.06); /* shadow-[0_14px_28px_rgba(15,23,42,0.06)] */
  box-sizing: border-box;
}

.ccd-insights-last-label-ref {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #94a3b8; /* text-slate-400 */
  margin: 0;
}

.ccd-insights-last-val-ref {
  margin-top: 6px; /* mt-1.5 */
  font-size: 15px;
  font-weight: 600;
  color: #0f172a; /* text-slate-950 */
  margin-bottom: 0;
}

.ccd-insights-empty-card-ref {
  margin-top: 4px; /* mt-4 */
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  border: 1px dashed #bfdbfe; /* border-blue-200 */
  background-color: rgba(255, 255, 255, 0.7); /* bg-white/70 */
  padding: 24px; /* p-6 */
  text-align: center;
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.04);
  box-sizing: border-box;
}

.ccd-insights-empty-icon-ref {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  height: 48px; /* h-12 */
  width: 48px; /* w-12 */
  align-items: center;
  justify-content: center;
  border-radius: 16px; /* rounded-2xl */
  background-color: #eff6ff; /* bg-blue-50 */
  color: #2a71ff;
  box-sizing: border-box;
}

.ccd-insights-empty-icon-ref svg {
  width: 20px; /* h-5 */
  height: 20px; /* w-5 */
}

.ccd-insights-empty-title-ref {
  margin-top: 12px; /* mt-3 */
  font-size: 1rem; /* text-base */
  font-weight: 700;
  color: #020617; /* slate-950 */
  margin-bottom: 0;
}

.ccd-insights-empty-sub-ref {
  margin-top: 6px; /* mt-1.5 */
  font-size: 13px;
  line-height: 1.25rem; /* leading-5 */
  color: #64748b; /* text-slate-500 */
  margin-bottom: 0;
}

.ccd-cancel-address-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  color: #ef4444; /* red-500 */
  background: none;
  border: none;
  cursor: pointer;
  transition: color 0.2s ease;
  padding: 0;
  font-family: inherit;
}

.ccd-cancel-address-link:hover:not(:disabled) {
  color: #dc2626; /* red-600 */
}

.ccd-cancel-address-link:disabled {
  color: #fca5a5;
  cursor: not-allowed;
}

/* ═══ DARK THEME — TakeawayDeliveryModal ═══ */
.dark .ccd-form-side { background: #1e293b; }
.dark .ccd-header {
  background: linear-gradient(135deg, rgba(30,41,59,0.97), rgba(15,23,42,0.97));
  border-bottom-color: #334155;
}
.dark .ccd-title { color: #f1f5f9; }
.dark .ccd-close-btn { color: #64748b; }
.dark .ccd-close-btn:hover { background: #334155; }

.dark .ccd-section-label { color: #64748b; }

.dark .ccd-option-card {
  background: #0f172a;
  border-color: #334155;
  color: #94a3b8;
}
.dark .ccd-option-card:hover { border-color: #3b82f6; color: #60a5fa; background: #1e293b; }
.dark .ccd-option-card--active { border-color: #0860e6 !important; color: #60a5fa !important; background: rgba(8,96,230,0.1) !important; }

.dark .customer-name-new { background-color: #0f172a !important; }
.dark .restore-text-new { color: #94a3b8; }

.dark .ccd-footer { border-top-color: #334155; }
.dark .ccd-btn-skip {
  background: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}
.dark .ccd-btn-skip:hover { background-color: #334155; border-color: #475569; }

/* Insights side */
.dark .ccd-insights-side { background: #0f172a; }
.dark .ccd-insights-header { color: #64748b; }
.dark .ccd-insights-customer-card {
  background: #1e293b;
  border-color: #334155;
}
.dark .ccd-insights-customer-name  { color: #f1f5f9; }
.dark .ccd-insights-customer-phone { color: #64748b; }
.dark .ccd-insights-order-opt { border-top-color: #334155; }
.dark .ccd-insights-opt-label { color: #64748b; }
.dark .ccd-insights-opt-value { color: #e2e8f0; }
.dark .ccd-insights-stat-tile {
  background: #1e293b;
  border-color: #334155;
}
.dark .ccd-insights-stat-label { color: #64748b; }
.dark .ccd-insights-stat-value { color: #f1f5f9; }
.dark .ccd-insights-last-tile {
  background: #1e293b;
  border-color: #334155;
}
.dark .ccd-insights-last-value { color: #e2e8f0; }
.dark .ccd-insights-empty {
  background: #1e293b;
  border-color: #334155;
}
.dark .ccd-insights-empty-icon { background: #1e3a8a; color: #93c5fd; }
.dark .ccd-insights-empty-title { color: #f1f5f9; }
.dark .ccd-insights-empty-sub  { color: #94a3b8; }
.dark .ccd-insights-loader { color: #64748b; }

/* Address cards */
.dark .ccd-addr-card {
  background: #0f172a;
  border-color: #334155;
}
.dark .ccd-addr-card:hover { border-color: #3b82f6; background: #1e293b; }
.dark .ccd-addr-card--active { border-color: #0860e6 !important; background: rgba(8,96,230,0.1) !important; }
.dark .ccd-addr-type    { color: #94a3b8; }
.dark .ccd-addr-line    { color: #cbd5e1; }
.dark .ccd-addr-line--muted { color: #64748b; }
.dark .ccd-delivery-address-header { color: #94a3b8; }

.dark .ccd-addr-type-option {
  background: #0f172a;
  border-color: #334155;
}
.dark .ccd-addr-type-option.active { border-color: #2a71ff; background: rgba(42,113,255,0.08); }
.dark .ccd-addr-type-label-text { color: #e2e8f0; }
.dark .ccd-addr-radio { background: #0f172a; border-color: #475569; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/table-layout/components/TakeawayDeliveryModal/TakeawayDeliveryModal.css"],"names":[],"mappings":"AAAA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;;+CAE+C;AAC/C;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,yFAAyF;EACzF,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,OAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd;;;oBAGkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,4BAA4B;AAC5B;EACE,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR;;qBAEmB;EACnB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iCAAiC;AACnC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;+CAE+C;AAC/C;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;+CAE+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf;;oBAEkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ,EAAE,UAAU;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,mBAAmB;EACnC,gBAAgB,EAAE,SAAS;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,YAAY;AACxB;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR;;oBAEkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C;;oBAEkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA,oDAAoD;;AAEpD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB;;;mBAGiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd;;0CAEwC;EACxC,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,yBAAyB,EAAE,oBAAoB;EAC/C,mBAAmB,EAAE,mBAAmB;EACxC,aAAa,EAAE,QAAQ;EACvB,2CAA2C,EAAE,cAAc;EAC3D,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe,EAAE,gBAAgB;EACjC,gBAAgB,EAAE,cAAc;EAChC,cAAc,EAAE,mBAAmB;EACnC,sBAAsB,EAAE,sBAAsB;EAC9C,yBAAyB,EAAE,cAAc;EACzC,eAAe;AACjB;;AAEA;EACE,eAAe,EAAE,YAAY;EAC7B,gBAAgB,EAAE,gBAAgB;EAClC,cAAc,EAAE,mBAAmB;EACnC,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS,EAAE,UAAU;AACvB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;EAChD,mBAAmB,EAAE,mBAAmB;EACxC,aAAa,EAAE,cAAc;EAC7B,eAAe;EACf,oCAAoC,EAAE,mBAAmB;EACzD,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB,EAAE,2BAA2B;EAClD,mBAAmB,EAAE,mBAAmB;AAC1C;;AAEA;EACE,qBAAqB,EAAE,mBAAmB;EAC1C,oCAAoC,EAAE,sBAAsB;EAC5D,gDAAgD,EAAE,+CAA+C;AACnG;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe,EAAE,YAAY;EAC7B,gBAAgB,EAAE,kBAAkB;EACpC,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,eAAe,EAAE,YAAY;EAC7B,cAAc,EAAE,mBAAmB;EACnC,oBAAoB,EAAE,cAAc;AACtC;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB,EAAE,qBAAqB;EAChD,mBAAmB;EACnB,cAAc;EACd,eAAe,EAAE,WAAW;EAC5B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB,EAAE,mBAAmB;EAC1C,mBAAmB,EAAE,eAAe;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU,EAAE,YAAY;EACxB,WAAW;EACX,kBAAkB;EAClB,mBAAmB,EAAE,aAAa;AACpC;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,yBAAyB;EACzB;;qDAEmD;AACrD;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,eAAe;AACf;EACE,eAAe;EACf,aAAa;EACb,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,yBAAyB,EAAE,qBAAqB;EAChD,0CAA0C,EAAE,mBAAmB;EAC/D,YAAY,EAAE,QAAQ;EACtB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB,EAAE,SAAS;EAC7B,cAAc,EAAE,SAAS;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ,EAAE,UAAU;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ,EAAE,UAAU;EACpB,mBAAmB,EAAE,SAAS;EAC9B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB,EAAE,qBAAqB;EAChD,aAAa,EAAE,QAAQ;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC;;gDAE8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB,EAAE,SAAS;EAC7B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,mBAAmB;EACnC,uBAAuB,EAAE,kBAAkB;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc,EAAE,mBAAmB;EACnC,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc,EAAE,mBAAmB;EACnC,kBAAkB,EAAE,oBAAoB;EACxC,mBAAmB,EAAE,SAAS;EAC9B,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA,mDAAmD;AACnD;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,kDAAkD;AAClD;EACE,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,iBAAiB;EAC5B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB,EAAE,iBAAiB;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY,EAAE,SAAS;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B,EAAE,iBAAiB;EAC/C,yBAAyB,EAAE,qBAAqB;EAChD,eAAe;EACf,yBAAyB,EAAE,gBAAgB;EAC3C,eAAe,EAAE,SAAS;EAC1B,cAAc,EAAE,mBAAmB;EACnC,eAAe;EACf,2CAA2C,EAAE,cAAc;EAC3D,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY,EAAE,SAAS;EACvB,4BAA4B,EAAE,iBAAiB;EAC/C,yBAAyB,EAAE,qBAAqB;EAChD,yBAAyB,EAAE,aAAa;EACxC,eAAe,EAAE,SAAS;EAC1B,eAAe,EAAE,YAAY;EAC7B,2CAA2C,EAAE,cAAc;EAC3D,sBAAsB;EACtB,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,8DAA8D;AAChE;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,gDAAgD;EAChD,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;6DAE6D;;AAE7D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC,EAAE,qBAAqB;EACvD,yBAAyB;EACzB,kBAAkB,EAAE,cAAc;EAClC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB,EAAE,mBAAmB;EAC7C,cAAc,EAAE,mBAAmB;EACnC,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW,EAAE,QAAQ;EACrB,YAAY,EAAE,QAAQ;EACtB,qBAAqB;EACrB,eAAe;EACf,gCAAgC;EAChC,cAAc,EAAE,mBAAmB;EACnC,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,WAAW;AACb;;AAEA;EACE;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,6DAA6D;EAC7D,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa,EAAE,QAAQ;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE;IACE,aAAa,EAAE,WAAW;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,aAAa;EACb,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,SAAS,EAAE,UAAU;EACrB,gBAAgB;EAChB,kBAAkB,EAAE,SAAS;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB,EAAE,oBAAoB;EAC/C,yBAAyB;EACzB,YAAY,EAAE,QAAQ;EACtB,gDAAgD,EAAE,+CAA+C;EACjG,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc,EAAE,mBAAmB;EACnC,SAAS;AACX;;AAEA;EACE,eAAe,EAAE,WAAW;EAC5B,aAAa;EACb,QAAQ,EAAE,YAAY;AACxB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB,EAAE,qBAAqB;EAChD,iBAAiB,EAAE,gBAAgB;EACnC,gBAAgB;EAChB,yBAAyB;EACzB,0CAA0C,EAAE,mBAAmB;EAC/D,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB,EAAE,2BAA2B;EAClD,yBAAyB,EAAE,mBAAmB;AAChD;;AAEA;EACE,qBAAqB;EACrB,yBAAyB,EAAE,eAAe;EAC1C,8CAA8C,EAAE,8CAA8C;AAChG;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY,EAAE,QAAQ;EACtB,WAAW,EAAE,QAAQ;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB,EAAE,eAAe;EACnC,yBAAyB;EACzB,cAAc;EACd,2CAA2C,EAAE,cAAc;EAC3D,sBAAsB;AACxB;;AAEA;EACE,WAAW,EAAE,UAAU;EACvB,YAAY,EAAE,UAAU;EACxB,iBAAiB;AACnB;;AAEA;EACE,eAAe,EAAE,WAAW;EAC5B,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE,cAAc;EACjC,cAAc,EAAE,mBAAmB;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS,EAAE,UAAU;EACrB,sBAAsB;AACxB;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB,EAAE,WAAW;EAC/B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAE,UAAU;EACpB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,8CAA8C,EAAE,wBAAwB;EACxE,2CAA2C,EAAE,mBAAmB;EAChE,kBAAkB,EAAE,gBAAgB;EACpC,0BAA0B,EAAE,qBAAqB;EACjD,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB,EAAE,YAAY;EAClC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS,EAAE,YAAY;EACvB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB,EAAE,qBAAqB;EAChD,mBAAmB,EAAE,eAAe;EACpC,yBAAyB;EACzB,iBAAiB,EAAE,SAAS;EAC5B,YAAY,EAAE,SAAS;EACvB,eAAe,EAAE,YAAY;EAC7B,cAAc,EAAE,mBAAmB;EACnC,8CAA8C,EAAE,6CAA6C;EAC7F,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB,EAAE,eAAe;EACpC,yBAAyB;EACzB,cAAc;EACd,iBAAiB,EAAE,SAAS;EAC5B,YAAY,EAAE,SAAS;EACvB,eAAe,EAAE,iBAAiB;EAClC,eAAe,EAAE,YAAY;EAC7B,gDAAgD,EAAE,+CAA+C;EACjG,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,cAAc,EAAE,4BAA4B;EAC5C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,8BAA8B,EAAE,qBAAqB;EACrD,6DAA6D;EAC7D,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa,EAAE,UAAU;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa,EAAE,WAAW;EAC5B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB,EAAE,SAAS;AAC/B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB,EAAE,oBAAoB;EAC/C,0CAA0C,EAAE,gBAAgB;EAC5D,aAAa,EAAE,QAAQ;EACvB,gDAAgD,EAAE,+CAA+C;EACjG,mBAAmB,EAAE,gBAAgB;EACrC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS,EAAE,UAAU;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc,EAAE,mBAAmB;EACnC,SAAS;AACX;;AAEA;EACE,eAAe,EAAE,SAAS;EAC1B,eAAe;EACf,cAAc,EAAE,mBAAmB;EACnC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB,EAAE,eAAe;EAC1C,iBAAiB,EAAE,gBAAgB;EACnC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB,EAAE,SAAS;EAC3B,mBAAmB;EACnB,yBAAyB,EAAE,qBAAqB;EAChD,yBAAyB,EAAE,gBAAgB;EAC3C,kBAAkB,EAAE,gBAAgB;EACpC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc,EAAE,mBAAmB;EACnC,SAAS;AACX;;AAEA;EACE,eAAe,EAAE,WAAW;EAC5B,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,mBAAmB;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ,EAAE,UAAU;EACpB,mBAAmB,EAAE,gBAAgB;EACrC,sBAAsB;AACxB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa,EAAE,QAAQ;EACvB,8CAA8C,EAAE,6CAA6C;EAC7F,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc,EAAE,mBAAmB;EACnC,SAAS;AACX;;AAEA;EACE,eAAe,EAAE,WAAW;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc,EAAE,mBAAmB;EACnC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,YAAY;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB,EAAE,qBAAqB;EAChD,0CAA0C,EAAE,gBAAgB;EAC5D,aAAa,EAAE,QAAQ;EACvB,8CAA8C,EAAE,6CAA6C;EAC7F,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc,EAAE,mBAAmB;EACnC,SAAS;AACX;;AAEA;EACE,eAAe,EAAE,WAAW;EAC5B,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,mBAAmB;EACnC,gBAAgB;AAClB;;AAEA;EACE,eAAe,EAAE,SAAS;EAC1B,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B,EAAE,oBAAoB;EAChD,0CAA0C,EAAE,gBAAgB;EAC5D,aAAa,EAAE,QAAQ;EACvB,kBAAkB;EAClB,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,YAAY,EAAE,SAAS;EACvB,WAAW,EAAE,SAAS;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB,EAAE,gBAAgB;EACrC,yBAAyB,EAAE,eAAe;EAC1C,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW,EAAE,QAAQ;EACrB,YAAY,EAAE,QAAQ;AACxB;;AAEA;EACE,gBAAgB,EAAE,SAAS;EAC3B,eAAe,EAAE,cAAc;EAC/B,gBAAgB;EAChB,cAAc,EAAE,cAAc;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe,EAAE,WAAW;EAC5B,eAAe;EACf,oBAAoB,EAAE,cAAc;EACpC,cAAc,EAAE,mBAAmB;EACnC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,YAAY;EAC5B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,cAAc,EAAE,YAAY;AAC9B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C,uBAAuB,mBAAmB,EAAE;AAC5C;EACE,6EAA6E;EAC7E,4BAA4B;AAC9B;AACA,mBAAmB,cAAc,EAAE;AACnC,uBAAuB,cAAc,EAAE;AACvC,6BAA6B,mBAAmB,EAAE;;AAElD,2BAA2B,cAAc,EAAE;;AAE3C;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,+BAA+B,qBAAqB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC3F,iCAAiC,gCAAgC,EAAE,yBAAyB,EAAE,yCAAyC,EAAE;;AAEzI,2BAA2B,oCAAoC,EAAE;AACjE,0BAA0B,cAAc,EAAE;;AAE1C,oBAAoB,yBAAyB,EAAE;AAC/C;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,4BAA4B,yBAAyB,EAAE,qBAAqB,EAAE;;AAE9E,kBAAkB;AAClB,2BAA2B,mBAAmB,EAAE;AAChD,6BAA6B,cAAc,EAAE;AAC7C;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,qCAAqC,cAAc,EAAE;AACrD,qCAAqC,cAAc,EAAE;AACrD,gCAAgC,yBAAyB,EAAE;AAC3D,gCAAgC,cAAc,EAAE;AAChD,gCAAgC,cAAc,EAAE;AAChD;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,cAAc,EAAE;AACjD;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,iCAAiC,cAAc,EAAE;AACjD;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,iCAAiC,mBAAmB,EAAE,cAAc,EAAE;AACtE,kCAAkC,cAAc,EAAE;AAClD,iCAAiC,cAAc,EAAE;AACjD,6BAA6B,cAAc,EAAE;;AAE7C,kBAAkB;AAClB;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,6BAA6B,qBAAqB,EAAE,mBAAmB,EAAE;AACzE,+BAA+B,gCAAgC,EAAE,yCAAyC,EAAE;AAC5G,0BAA0B,cAAc,EAAE;AAC1C,0BAA0B,cAAc,EAAE;AAC1C,8BAA8B,cAAc,EAAE;AAC9C,qCAAqC,cAAc,EAAE;;AAErD;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,qCAAqC,qBAAqB,EAAE,iCAAiC,EAAE;AAC/F,kCAAkC,cAAc,EAAE;AAClD,wBAAwB,mBAAmB,EAAE,qBAAqB,EAAE","sourcesContent":["@keyframes ccdSlideIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* ══════════════════════════════════════════\n   FORM SIDE (left column)\n   ══════════════════════════════════════════ */\n.ccd-form-side {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n  height: 100%;\n  background: #fff;\n}\n\n.ccd-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #f1f5f9;\n  background: linear-gradient(135deg, rgba(255, 251, 235, 0.96), rgba(255, 255, 255, 0.92));\n  flex-shrink: 0;\n}\n\n.ccd-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.025em;\n  line-height: 1.25;\n  margin: 0;\n}\n\n.ccd-close-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  width: 36px;\n  height: 36px;\n  color: #64748b;\n  flex-shrink: 0;\n  transition: background-color 0.2s;\n}\n.ccd-close-btn:hover {\n  background: #f1f5f9;\n}\n\n/* Body */\n.ccd-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px 24px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 18px;\n}\n\n/* Section wrapper */\n.ccd-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ccd-section-label {\n  font-size: 10px;\n  font-weight: 700;\n  color: #64748b;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n/* ── ORDER OPTION cards ── */\n.ccd-option-cards {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n}\n\n.ccd-option-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 14px 10px;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 10px;\n  background: #fff;\n  cursor: pointer;\n  font-size: 0.813rem;\n  font-weight: 500;\n  color: #6b7280;\n  transition:\n    border-color 0.15s,\n    color 0.15s,\n    background 0.15s;\n}\n\n.ccd-option-card:hover {\n  border-color: #bfdbfe;\n  color: #1d4ed8;\n  background: #f0f7ff;\n}\n\n.ccd-option-card--active {\n  border-color: #0860e6 !important;\n  color: #0860e6 !important;\n  background: #f0f7ff !important;\n  font-weight: 600;\n}\n\n.ccd-option-icon {\n  width: 22px;\n  height: 22px;\n  flex-shrink: 0;\n  stroke-width: 1.5;\n}\n\n/* ── Input fields row — stacked ── */\n.ccd-fields-row {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.ccd-field-col {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n/* Customer name overrides */\n.customer-name-new {\n  background-color: white !important;\n}\n\n/* WhatsApp checkbox */\n.check-wrapper-box-new {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 2px;\n}\n\n.restore-text-new {\n  font-size: 0.813rem;\n  font-weight: 500;\n  color: #6b7280;\n}\n\n/* ── Footer ── */\n.ccd-footer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 24px;\n  border-top: 1px solid #f0f2f5;\n  flex-shrink: 0;\n}\n\n.ccd-btn-skip {\n  flex: 1;\n  height: 48px;\n  padding: 10px 16px;\n  border: 1px solid var(--surface-black);\n  border-radius: 20px;\n  background: #fff;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #334155;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition:\n    background-color 0.2s,\n    border-color 0.2s;\n  white-space: nowrap;\n}\n.ccd-btn-skip:hover {\n  background-color: #f8fafc;\n  border-color: #cbd5e1;\n}\n.ccd-btn-skip:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.ccd-btn-add {\n  flex: 1;\n  height: 48px;\n  padding: 10px 16px;\n  border: 1px solid transparent;\n  border-radius: 20px;\n  background: #3b82f6;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #fff;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  transition: background-color 0.2s;\n}\n.ccd-btn-add:hover {\n  background-color: #2563eb;\n}\n.ccd-btn-add:disabled {\n  background-color: #93c5fd;\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ══════════════════════════════════════════\n   INSIGHTS SIDE (right column)\n   ══════════════════════════════════════════ */\n.ccd-insights-side {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  background: #f8fafc;\n  height: 100%;\n  overflow: hidden;\n}\n\n.ccd-insights-header {\n  padding: 22px 20px 12px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  flex-shrink: 0;\n}\n\n.ccd-insights-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n/* Customer card */\n.ccd-insights-customer-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.ccd-insights-customer-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.ccd-insights-customer-name {\n  font-size: 16px;\n  font-weight: 700;\n  color: #111827;\n  line-height: 1.2;\n}\n\n.ccd-insights-customer-phone {\n  font-size: 0.813rem;\n  color: #6b7280;\n  margin-top: 2px;\n}\n\n.ccd-insights-badge {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  padding: 3px 8px;\n  border-radius: 999px;\n  white-space: nowrap;\n  flex-shrink: 0;\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.ccd-insights-badge.new {\n  background: #f0fdf4;\n  color: #15803d;\n  border: 1px solid #bbf7d0;\n}\n\n.ccd-insights-order-opt {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  padding-top: 8px;\n  border-top: 1px solid #f0f2f5;\n}\n\n.ccd-insights-opt-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.ccd-insights-opt-value {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n/* Stats 2×2 grid */\n.ccd-insights-stats-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.ccd-insights-stat-tile {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 16px;\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ccd-insights-stat-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.ccd-insights-stat-value {\n  font-size: 20px;\n  font-weight: 800;\n  color: #111827;\n  line-height: 1.1;\n}\n\n/* Last ordered */\n.ccd-insights-last-tile {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ccd-insights-last-value {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n/* Loader */\n.ccd-insights-loader {\n  font-size: 0.813rem;\n  color: #6b7280;\n  text-align: center;\n  padding: 12px 0;\n  animation: pulse 1.4s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.4;\n  }\n}\n\n.ccd-insights-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 24px;\n  border: 1px solid #f1f5f9;\n  border-radius: 16px;\n  background: #fff;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  gap: 8px;\n}\n\n.ccd-insights-empty-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: #eff6ff;\n  color: #2a71ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-bottom: 16px;\n}\n\n.ccd-insights-empty-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 8px 0;\n}\n\n.ccd-insights-empty-sub {\n  font-size: 0.875rem;\n  color: #64748b;\n  margin: 0;\n  line-height: 1.5;\n  max-width: 320px;\n}\n\n/* ══════════════════════════════════════════\n   DELIVERY ADDRESS SECTION\n   ══════════════════════════════════════════ */\n.ccd-addr-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.ccd-addr-add-btn {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #0860e6;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 2px 0;\n  transition: color 0.12s;\n}\n.ccd-addr-add-btn:hover {\n  color: #0751c4;\n}\n\n.ccd-addr-loader {\n  font-size: 0.8rem;\n  color: #9ca3af;\n  padding: 8px 0;\n}\n\n.ccd-addr-empty {\n  font-size: 0.8rem;\n  color: #9ca3af;\n  margin: 0;\n  padding: 6px 0;\n}\n\n/* Saved address cards */\n.ccd-addr-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ccd-addr-card {\n  padding: 10px 12px;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 8px;\n  cursor: pointer;\n  transition:\n    border-color 0.12s,\n    background 0.12s;\n  background: #fff;\n}\n\n.ccd-addr-card:hover {\n  border-color: #93c5fd;\n  background: #f8fbff;\n}\n\n.ccd-addr-card--active {\n  border-color: #0860e6 !important;\n  background: #eff6ff !important;\n}\n\n.ccd-addr-card-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 4px;\n}\n\n.ccd-addr-type {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #374151;\n}\n\n.ccd-addr-selected-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #0860e6;\n  flex-shrink: 0;\n}\n\n.ccd-addr-line {\n  font-size: 0.8rem;\n  color: #374151;\n  margin: 0;\n  line-height: 1.4;\n}\n\n.ccd-addr-line--muted {\n  color: #9ca3af;\n}\n\n/* New address form */\n.ccd-addr-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  box-sizing: border-box;\n}\n\n/* ── Delivery address header ── */\n.ccd-delivery-address-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px; /* gap-2 */\n  font-size: 11px;\n  font-weight: 600;\n  color: #1e293b; /* text-slate-800 */\n  margin-top: 16px; /* mt-4 */\n}\n\n.ccd-delivery-address-header-inner {\n  display: flex;\n  align-items: center;\n  gap: 6px; /* gap-1.5 */\n}\n\n.ccd-delivery-address-header-icon {\n  width: 12px; /* h-3 w-3 */\n  height: 12px;\n  color: #2a71ff;\n  flex-shrink: 0;\n}\n\n/* ── Address container section (single card) ── */\n.ccd-address-section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  box-sizing: border-box;\n  margin-top: 12px;\n}\n\n/* ── Address type options ── */\n.ccd-addr-type-options {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n  margin-bottom: 4px;\n}\n\n.ccd-addr-type-option {\n  flex: 1;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 8px 12px;\n  cursor: pointer;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  transition:\n    border-color 0.15s,\n    background 0.15s;\n}\n\n.ccd-addr-type-option.active {\n  border-color: #2a71ff;\n  background: rgba(42, 113, 255, 0.06);\n}\n\n.ccd-addr-type-label-text {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.ccd-addr-radio {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid #cbd5e1;\n  background: #ffffff;\n  flex-shrink: 0;\n  margin-top: 2px;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.ccd-addr-radio.active {\n  border-color: #2a71ff;\n  background: #2a71ff;\n}\n\n.ccd-addr-radio.active::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #ffffff;\n}\n\n/* ── Inputs ── */\n.ccd-addr-inputs-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  width: 100%;\n}\n\n.ccd-addr-input-group {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.ccd-addr-input-group--full {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ccd-addr-input-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #0f172a;\n  line-height: 1;\n}\n\n.ccd-addr-input-wrap {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 30px;\n  padding: 0 14px;\n  height: 44px;\n  background: #ffffff;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  transition:\n    border-color 0.15s,\n    box-shadow 0.15s;\n  box-sizing: border-box;\n  position: relative;\n}\n\n.ccd-addr-input-wrap:focus-within {\n  border-color: #94a3b8;\n  box-shadow: 0 0 0 1px #94a3b8;\n}\n\n.ccd-addr-input-wrap svg {\n  flex-shrink: 0;\n  color: #94a3b8;\n  width: 16px;\n  height: 16px;\n}\n\n.ccd-addr-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  color: #0f172a;\n  background: transparent;\n  min-width: 0;\n  padding: 0;\n  height: 100%;\n}\n\n.ccd-addr-input::placeholder {\n  color: #94a3b8;\n}\n\n.ccd-addr-input--no-icon {\n  padding-left: 0;\n}\n\n/* hide number input spinners */\n.ccd-addr-input[type=\"number\"]::-webkit-inner-spin-button,\n.ccd-addr-input[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.ccd-addr-input[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.ccd-addr-error {\n  color: #ef4444;\n  font-size: 11px;\n  font-weight: 500;\n  margin-top: 2px;\n  margin-bottom: 0px;\n}\n\n/* Legacy classes kept for other usages */\n.addCusomerText {\n  font-weight: 700;\n  font-size: 1.5rem;\n  line-height: 100%;\n  color: var(--surface-g5);\n}\n\n.deliveryOptionsRadioButtons {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 3px;\n  margin-bottom: 10px;\n}\n\n.skip-button-container-new {\n  margin-top: 10px;\n  display: flex;\n  gap: 10px;\n}\n\n.ccd-insights-inline-body {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.ccd-insights-empty-header-title {\n  margin-bottom: 24px;\n  text-align: left;\n  width: 100%;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #2a71ff;\n  margin-top: 0;\n}\n\n.ccd-insights-section-title {\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #2a71ff;\n  margin-top: 8px;\n}\n\n.ccd-insights-actions-row {\n  margin-top: 24px;\n  display: flex;\n  gap: 12px;\n  width: 100%;\n}\n\n/* ── REFERENCE DESIGN STYLES (NO TAILWIND/MUI) ── */\n\n.ccd-ref-container {\n  border-radius: 16px;\n  border: 1px solid #d1fae5;\n  background-color: #ffffff;\n  padding: 20px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.ccd-ref-header-row {\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.ccd-ref-avatar {\n  display: flex;\n  height: 48px;\n  width: 48px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  border: 1px solid #d1fae5;\n  background-color: #ecfdf5;\n  color: #059669;\n}\n\n.ccd-ref-avatar-icon {\n  height: 24px;\n  width: 24px;\n}\n\n.ccd-ref-customer-name {\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n  font-size: 1rem;\n}\n\n.ccd-ref-customer-phone {\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748b;\n  margin: 2px 0 0 0;\n}\n\n.ccd-ref-stats-grid {\n  margin-bottom: 20px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n.ccd-ref-stat-tile {\n  border-radius: 16px;\n  border: 1px solid #f1f5f9;\n  background-color: #f8fafc;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ccd-ref-stat-label {\n  margin: 0;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #94a3b8;\n}\n\n.ccd-ref-stat-value {\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.ccd-ref-stat-value-sm {\n  margin: 0;\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.ccd-ref-stat-tile-pink {\n  border-radius: 14px;\n  border: 1px solid #fce7f3;\n  background-color: #fdf2f8;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ccd-ref-stat-label-pink {\n  margin: 0;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #ec4899;\n}\n\n.ccd-ref-stat-value-pink {\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: #be185d;\n}\n\n.ccd-ref-pts-label {\n  font-size: 0.75rem;\n  font-weight: 400;\n  color: #db2777;\n}\n\n.ccd-ref-select-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  border-radius: 14px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition:\n    background-color 0.2s,\n    border-color 0.2s,\n    box-shadow 0.2s;\n  border: 1px solid #059669;\n  min-height: 36px;\n  padding: 8px 16px;\n  height: 48px;\n  width: 100%;\n  background-color: #059669;\n  color: #ffffff;\n  box-shadow:\n    0 4px 6px -1px rgba(16, 185, 129, 0.2),\n    0 2px 4px -2px rgba(16, 185, 129, 0.2);\n  cursor: pointer;\n  outline: none;\n}\n\n.ccd-ref-select-btn:hover:not(:disabled) {\n  background-color: #047857;\n  border-color: #047857;\n}\n\n.ccd-ref-select-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ── Delivery Mode Section ── */\n.ccd-delivery-section {\n  background: #ffffff;\n  border: 1px solid #dbeafe; /* border-blue-100 */\n  border-radius: 26px; /* rounded-[26px] */\n  padding: 16px; /* p-4 */\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  margin-bottom: 8px;\n  margin-top: 8px;\n}\n\n.ccd-delivery-section-label {\n  font-size: 11px; /* text-[11px] */\n  font-weight: 700; /* font-bold */\n  color: #94a3b8; /* text-slate-400 */\n  letter-spacing: 0.18em; /* tracking-[0.18em] */\n  text-transform: uppercase; /* uppercase */\n  margin: 0 0 4px;\n}\n\n.ccd-delivery-section-desc {\n  font-size: 14px; /* text-sm */\n  font-weight: 500; /* font-medium */\n  color: #475569; /* text-slate-600 */\n  margin: 0 0 16px;\n}\n\n/* ── Mode options ── */\n.ccd-delivery-mode-options {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px; /* gap-3 */\n}\n\n@media (max-width: 640px) {\n  .ccd-delivery-mode-options {\n    grid-template-columns: 1fr;\n  }\n}\n\n.ccd-delivery-mode-option {\n  border: 1px solid #e2e8f0; /* border-slate-200 */\n  border-radius: 22px; /* rounded-[22px] */\n  padding: 16px; /* px-4 py-4 */\n  cursor: pointer;\n  background: rgba(248, 250, 252, 0.7); /* bg-slate-50/70 */\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  transition: all 0.2s ease;\n  text-align: left;\n}\n\n.ccd-delivery-mode-option:hover {\n  border-color: #cbd5e1; /* hover:border-slate-300 */\n  background: #ffffff; /* hover:bg-white */\n}\n\n.ccd-delivery-mode-option.active {\n  border-color: #2a71ff; /* border-primary */\n  background: rgba(42, 113, 255, 0.06); /* bg-primary/[0.06] */\n  box-shadow: 0 10px 30px rgba(42, 113, 255, 0.12); /* shadow-[0_10px_30px_rgba(42,113,255,0.12)] */\n}\n\n.ccd-delivery-mode-option-text {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ccd-delivery-mode-option-title {\n  font-size: 14px; /* text-sm */\n  font-weight: 600; /* font-semibold */\n  color: #0f172a; /* text-slate-900 */\n}\n\n.ccd-delivery-mode-option-desc {\n  font-size: 12px; /* text-xs */\n  color: #64748b; /* text-slate-500 */\n  line-height: 1.25rem; /* leading-5 */\n}\n\n.ccd-delivery-radio {\n  width: 20px; /* h-5 w-5 */\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid #cbd5e1; /* border-slate-300 */\n  background: #ffffff;\n  flex-shrink: 0;\n  margin-top: 2px; /* mt-0.5 */\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.ccd-delivery-radio.active {\n  border-color: #2a71ff; /* border-primary */\n  background: #2a71ff; /* bg-primary */\n}\n\n.ccd-delivery-radio.active::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 8px; /* h-2 w-2 */\n  height: 8px;\n  border-radius: 50%;\n  background: #ffffff; /* bg-white */\n}\n\n/* ── Slots Picker ── */\n.ccd-delivery-slots-container {\n  margin-top: 16px;\n  border-radius: 20px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  padding: 12px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.ccd-delivery-slots-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.ccd-delivery-slots-clock-icon {\n  width: 14px;\n  height: 14px;\n  color: #2a71ff;\n  flex-shrink: 0;\n}\n\n/* Date Chips */\n.ccd-delivery-date-chips-container {\n  margin-top: 12px;\n  margin-left: -12px;\n  margin-right: -12px;\n  padding-left: 12px;\n  padding-right: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  overflow-x: auto;\n  scrollbar-width: thin;\n  padding-bottom: 8px;\n}\n\n.ccd-delivery-date-chips-container::-webkit-scrollbar {\n  height: 4px;\n}\n\n.ccd-delivery-date-chips-container::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 10px;\n}\n\n.ccd-delivery-date-chips-container::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 10px;\n}\n\n.ccd-delivery-date-chips-container::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n.ccd-delivery-date-chip-btn {\n  padding: 6px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 9999px;\n  border: 1px solid #cbd5e1;\n  background-color: #ffffff;\n  color: #475569;\n  transition: all 0.15s ease-in-out;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.ccd-delivery-date-chip-btn:hover {\n  border-color: #94a3b8;\n  background-color: #f8fafc;\n}\n\n.ccd-delivery-date-chip-btn--selected {\n  border-color: #2a71ff !important;\n  background-color: #2a71ff !important;\n  color: #ffffff !important;\n  box-shadow:\n    0 4px 6px -1px rgba(42, 113, 255, 0.2),\n    0 2px 4px -1px rgba(42, 113, 255, 0.2) !important;\n}\n\n.ccd-delivery-date-chip-btn--selected:hover {\n  background-color: #1e53d0 !important;\n  border-color: #1e53d0 !important;\n}\n\n/* Slots Grid */\n.ccd-delivery-slots-grid {\n  margin-top: 8px;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 6px;\n}\n\n@media (min-width: 640px) {\n  .ccd-delivery-slots-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (min-width: 1280px) {\n  .ccd-delivery-slots-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.ccd-delivery-slot-btn--selected {\n  border-radius: 12px;\n  border: 1px solid #2a71ff;\n  background-color: #eff6ff;\n  color: #2a71ff;\n  padding: 8px 10px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n  text-align: left;\n  transition: all 0.15s ease-in-out;\n  cursor: pointer;\n  width: 100%;\n  box-shadow: 0 8px 20px rgba(42, 113, 255, 0.1);\n}\n\n.ccd-delivery-slot-btn--unselected {\n  border-radius: 12px;\n  border: 1px solid #cbd5e1;\n  background-color: rgba(241, 245, 249, 0.8);\n  color: #475569;\n  padding: 8px 10px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n  text-align: left;\n  transition: all 0.15s ease-in-out;\n  cursor: pointer;\n  width: 100%;\n}\n\n.ccd-delivery-slot-btn--unselected:hover {\n  border-color: #94a3b8;\n  background-color: #ffffff;\n}\n\n.ccd-delivery-slots-loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 24px 0;\n}\n\n.ccd-delivery-slots-spinner {\n  width: 24px;\n  height: 24px;\n  border: 2px solid #e2e8f0;\n  border-top-color: #2a71ff;\n  border-radius: 50%;\n  animation: ccd-delivery-spin 0.7s linear infinite;\n  flex-shrink: 0;\n}\n\n@keyframes ccd-delivery-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.ccd-delivery-slots-empty {\n  font-size: 14px;\n  color: #64748b;\n  text-align: center;\n  padding: 16px 0;\n  margin: 0;\n  width: 100%;\n  grid-column: span 2;\n}\n\n/* ── Saved Addresses Section ── */\n.ccd-saved-addresses-section {\n  border-radius: 16px;\n  border: 1px solid #cbd5e1; /* border-slate-200 */\n  background-color: rgba(241, 245, 249, 0.8); /* bg-slate-50/80 */\n  padding: 8px; /* p-2 */\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n}\n\n.ccd-saved-addresses-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px; /* mb-2 */\n  padding: 0 4px; /* px-1 */\n  box-sizing: border-box;\n}\n\n.ccd-saved-addresses-title {\n  display: block;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #64748b; /* text-slate-500 */\n}\n\n.ccd-add-address-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px; /* gap-1 */\n  font-size: 11px;\n  font-weight: 600;\n  color: #2a71ff;\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: color 0.2s ease;\n  padding: 0;\n  font-family: inherit;\n}\n\n.ccd-add-address-link:hover:not(:disabled) {\n  color: #1c55d0;\n}\n\n.ccd-add-address-link:disabled {\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.ccd-saved-addresses-grid {\n  display: grid;\n  gap: 8px; /* gap-2 */\n  padding-bottom: 4px; /* pb-1 */\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.ccd-saved-address-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  border-radius: 16px;\n  border: 1px solid #cbd5e1; /* border-slate-200 */\n  padding: 16px; /* p-4 */\n  text-align: left;\n  background-color: #ffffff;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.ccd-saved-address-card:hover {\n  border-color: #94a3b8; /* hover:border-slate-300 */\n}\n\n.ccd-saved-address-card.active {\n  border-color: #2a71ff !important;\n  background-color: #ffffff !important;\n  box-shadow:\n    0 1px 2px 0 rgba(0, 0, 0, 0.05),\n    0 0 0 1px rgba(42, 113, 255, 0.2) !important;\n}\n\n.ccd-saved-address-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 4px; /* mb-1 */\n  box-sizing: border-box;\n}\n\n.ccd-saved-address-type-label {\n  font-size: 12px;\n  font-weight: 700;\n  color: #1e293b; /* text-slate-800 */\n  letter-spacing: 0.025em; /* tracking-wide */\n  text-transform: uppercase;\n}\n\n.ccd-edit-address-pen-btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #94a3b8; /* text-slate-400 */\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.ccd-saved-address-card:hover .ccd-edit-address-pen-btn {\n  opacity: 1;\n}\n\n.ccd-saved-address-description {\n  font-size: 12px;\n  color: #64748b; /* text-slate-500 */\n  line-height: 1.625; /* leading-relaxed */\n  padding-right: 24px; /* pr-6 */\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n/* ── Disabled states for Address type options ── */\n.ccd-addr-type-option.disabled {\n  opacity: 0.5;\n  background: #f9fafb;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.ccd-addr-radio.disabled {\n  background: #f3f4f6;\n  border-color: #e5e7eb;\n}\n\n/* ── Visual disabled select/add button state ── */\n.ccd-ref-select-btn.visual-disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background-color: #9ca3af !important;\n  border-color: #9ca3af !important;\n  box-shadow: none !important;\n}\n\n/* ── Charges Section ── */\n.ccd-charges-section {\n  box-sizing: border-box;\n  margin-top: 12px;\n}\n\n/* New Charges Layout */\n.ccd-charges-row {\n  display: flex;\n  align-items: center;\n  gap: 12px; /* gap-3 (12px) */\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.ccd-charge-group {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.ccd-charge-label {\n  margin-bottom: 6px; /* mb-1.5 (6px) */\n  display: block;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: #94a3b8; /* text-slate-400 */\n}\n\n.ccd-charge-input-wrap {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.ccd-charge-currency-prefix {\n  display: flex;\n  height: 40px; /* h-10 */\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px 0 0 12px; /* rounded-l-xl */\n  border: 1px solid #cbd5e1; /* border-slate-200 */\n  border-right: 0;\n  background-color: #f8fafc; /* bg-slate-50 */\n  padding: 0 12px; /* px-3 */\n  color: #64748b; /* text-slate-500 */\n  font-size: 14px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */\n  box-sizing: border-box;\n}\n\n.ccd-charge-input {\n  display: flex;\n  width: 100%;\n  height: 40px; /* h-10 */\n  border-radius: 0 12px 12px 0; /* rounded-r-xl */\n  border: 1px solid #cbd5e1; /* border-slate-200 */\n  background-color: #ffffff; /* bg-white */\n  padding: 0 12px; /* px-3 */\n  font-size: 14px; /* text-sm */\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */\n  box-sizing: border-box;\n  outline: none;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.ccd-charge-input:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 1px #3b82f6, 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.ccd-charge-input::placeholder {\n  color: #94a3b8;\n}\n\n.ccd-loader-inside-input {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n}\n\n/* ── Edit Address actions ── */\n.ccd-edit-address-actions {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  width: 100%;\n  margin-top: 16px;\n}\n\n.ccd-edit-address-btn-cancel {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  border-radius: 14px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  border: 1px solid #cbd5e1;\n  height: 48px;\n  background-color: #ffffff;\n  color: #64748b;\n  cursor: pointer;\n  outline: none;\n}\n\n.ccd-edit-address-btn-cancel:hover:not(:disabled) {\n  background-color: #f8fafc;\n  color: #334155;\n  border-color: #94a3b8;\n}\n\n.ccd-edit-address-btn-update {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  border-radius: 14px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  border: 1px solid #0860e6;\n  height: 48px;\n  background-color: #0860e6;\n  color: #ffffff;\n  box-shadow: 0 4px 6px -1px rgba(8, 96, 230, 0.2);\n  cursor: pointer;\n  outline: none;\n}\n\n.ccd-edit-address-btn-update:hover:not(:disabled) {\n  background-color: #0751c4;\n  border-color: #0751c4;\n}\n\n.ccd-edit-address-btn-update:disabled {\n  background-color: #cbd5e1;\n  border-color: #cbd5e1;\n  color: #94a3b8;\n  opacity: 0.6;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n/* ────────────────────────────────────────────────────────\n   REFERENCE IMPLEMENTATION STYLES (NO TAILWIND)\n   ──────────────────────────────────────────────────────── */\n\n.ccd-header-ref {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #f1f5f9; /* border-slate-100 */\n  background-color: #ffffff;\n  padding: 16px 20px; /* px-5 py-4 */\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.ccd-title-ref {\n  font-size: 1.35rem;\n  font-weight: 700;\n  letter-spacing: -0.025em; /* tracking-tight */\n  color: #0f172a; /* text-slate-950 */\n  margin: 0;\n}\n\n.ccd-close-btn-ref {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: transparent;\n  border: 1px solid transparent;\n  width: 32px; /* h-8 */\n  height: 32px; /* w-8 */\n  border-radius: 9999px;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  color: #64748b; /* text-slate-500 */\n  outline: none;\n  padding: 0;\n}\n\n.ccd-close-btn-ref:hover {\n  background-color: #f1f5f9;\n}\n\n.ccd-split-grid {\n  display: grid;\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n}\n\n@media (min-width: 1024px) {\n  .ccd-split-grid {\n    grid-template-columns: 1.18fr 0.82fr;\n  }\n}\n\n.ccd-form-side-ref {\n  position: relative;\n  display: flex;\n  height: 100%;\n  min-height: 0;\n  min-width: 0;\n  flex-direction: column;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\n  box-sizing: border-box;\n}\n\n.ccd-form-content-ref {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding: 16px; /* p-4 */\n  overflow: hidden;\n  box-sizing: border-box;\n  height: 100%;\n}\n\n@media (min-width: 1024px) {\n  .ccd-form-content-ref {\n    padding: 20px; /* lg:p-5 */\n  }\n}\n\n.ccd-form-scrollable-ref {\n  margin-top: 0;\n  display: flex;\n  min-height: 0;\n  flex: 1;\n  flex-direction: column;\n  gap: 12px; /* gap-3 */\n  overflow-y: auto;\n  padding-right: 4px; /* pr-1 */\n  box-sizing: border-box;\n}\n\n.ccd-order-option-section-ref {\n  border-radius: 20px;\n  border: 1px solid #dbeafe; /* border-blue-100 */\n  background-color: #ffffff;\n  padding: 8px; /* p-2 */\n  box-shadow: 0 16px 36px rgba(42, 113, 255, 0.08); /* shadow-[0_16px_36px_rgba(42,113,255,0.08)] */\n  box-sizing: border-box;\n}\n\n.ccd-section-label-ref {\n  font-size: 9px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: #94a3b8; /* text-slate-400 */\n  margin: 0;\n}\n\n.ccd-option-grid-ref {\n  margin-top: 6px; /* mt-1.5 */\n  display: grid;\n  gap: 6px; /* gap-1.5 */\n}\n\n@media (min-width: 640px) {\n  .ccd-option-grid-ref {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.ccd-option-card-ref {\n  border-radius: 16px;\n  border: 1px solid #e2e8f0; /* border-slate-200 */\n  padding: 8px 10px; /* px-2.5 py-2 */\n  text-align: left;\n  transition: all 0.2s ease;\n  background-color: rgba(248, 250, 252, 0.8); /* bg-slate-50/80 */\n  cursor: pointer;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.ccd-option-card-ref:hover {\n  border-color: #cbd5e1; /* hover:border-slate-300 */\n  background-color: #ffffff; /* hover:bg-white */\n}\n\n.ccd-option-card-ref.active {\n  border-color: #2a71ff;\n  background-color: #eff6ff; /* bg-blue-50 */\n  box-shadow: 0 8px 20px rgba(42, 113, 255, 0.1); /* shadow-[0_8px_20px_rgba(42,113,255,0.10)] */\n}\n\n.ccd-option-card-inner-ref {\n  display: flex;\n  min-height: 60px;\n  flex-direction: column;\n  justify-content: space-between;\n  box-sizing: border-box;\n}\n\n.ccd-option-icon-container-ref {\n  display: flex;\n  height: 28px; /* h-7 */\n  width: 28px; /* w-7 */\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px; /* rounded-lg */\n  background-color: #ffffff;\n  color: #2a71ff;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */\n  box-sizing: border-box;\n}\n\n.ccd-option-icon-container-ref svg {\n  width: 14px; /* h-3.5 */\n  height: 14px; /* w-3.5 */\n  stroke-width: 2px;\n}\n\n.ccd-option-text-ref {\n  margin-top: 6px; /* mt-1.5 */\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1rem; /* leading-4 */\n  color: #0f172a; /* text-slate-900 */\n  margin-bottom: 0;\n}\n\n.ccd-inputs-grid-ref {\n  display: grid;\n  gap: 12px; /* gap-3 */\n  box-sizing: border-box;\n}\n\n@media (min-width: 640px) {\n  .ccd-inputs-grid-ref {\n    grid-template-columns: 1.05fr 1fr;\n  }\n}\n\n.ccd-input-label-ref {\n  margin-bottom: 6px; /* mb-1.5 */\n  display: block;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: #94a3b8; /* text-slate-400 */\n}\n\n.ccd-mobile-input-row-ref {\n  display: flex;\n  flex-direction: column;\n  gap: 8px; /* gap-2 */\n  position: relative;\n  box-sizing: border-box;\n}\n\n@media (min-width: 640px) {\n  .ccd-mobile-input-row-ref {\n    flex-direction: row;\n  }\n}\n\n.ccd-footer-ref {\n  z-index: 10;\n  border-top: 1px solid rgba(226, 232, 240, 0.8); /* border-slate-200/80 */\n  background-color: rgba(248, 250, 252, 0.95); /* bg-slate-50/95 */\n  padding: 10px 16px; /* px-4 py-2.5 */\n  backdrop-filter: blur(4px); /* backdrop-blur-sm */\n  box-sizing: border-box;\n}\n\n@media (min-width: 1024px) {\n  .ccd-footer-ref {\n    padding: 10px 20px; /* lg:px-5 */\n  }\n}\n\n.ccd-footer-inner-ref {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px; /* gap-2.5 */\n  box-sizing: border-box;\n}\n\n.ccd-btn-skip-ref {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-weight: 500;\n  border: 1px solid #cbd5e1; /* border-slate-200 */\n  border-radius: 20px; /* rounded-xl */\n  background-color: #ffffff;\n  padding: 8px 20px; /* px-5 */\n  height: 40px; /* h-10 */\n  font-size: 14px; /* text-sm */\n  color: #334155; /* text-slate-700 */\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06); /* shadow-[0_10px_24px_rgba(15,23,42,0.06)] */\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.ccd-btn-skip-ref:hover {\n  background-color: #f8fafc; /* hover:bg-slate-50 */\n}\n\n.ccd-btn-skip-ref:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.ccd-btn-add-ref {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-weight: 500;\n  border: 1px solid transparent;\n  border-radius: 20px; /* rounded-xl */\n  background-color: #2a71ff;\n  color: #ffffff;\n  padding: 8px 20px; /* px-5 */\n  height: 40px; /* h-10 */\n  min-width: 82px; /* min-w-[82px] */\n  font-size: 14px; /* text-sm */\n  box-shadow: 0 10px 28px rgba(42, 113, 255, 0.24); /* shadow-[0_10px_28px_rgba(42,113,255,0.24)] */\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.ccd-btn-add-ref:hover {\n  background-color: #1f63ea; /* hover:bg-[#1f63ea] */\n}\n\n.ccd-btn-add-ref:disabled {\n  background-color: #e2e8f0; /* disabled:bg-slate-200 */\n  color: #94a3b8; /* disabled:text-slate-500 */\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n.ccd-insights-side-ref {\n  display: flex;\n  height: 100%;\n  min-height: 0;\n  min-width: 0;\n  flex-direction: column;\n  border-left: 1px solid #f1f5f9; /* border-slate-100 */\n  background: linear-gradient(180deg, #eff6ff 0%, #ffffff 100%);\n  box-sizing: border-box;\n}\n\n.ccd-insights-content-ref {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding: 14px; /* p-3.5 */\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\n@media (min-width: 1024px) {\n  .ccd-insights-content-ref {\n    padding: 16px; /* lg:p-4 */\n  }\n}\n\n.ccd-insights-title-ref {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.2em;\n  color: #2a71ff;\n  margin: 0 0 12px 0; /* mt-3 */\n}\n\n.ccd-insights-card-ref {\n  border-radius: 22px;\n  border: 1px solid #dbeafe; /* border-blue-100 */\n  background-color: rgba(255, 255, 255, 0.9); /* bg-white/90 */\n  padding: 16px; /* p-4 */\n  box-shadow: 0 18px 38px rgba(42, 113, 255, 0.08); /* shadow-[0_18px_38px_rgba(42,113,255,0.08)] */\n  margin-bottom: 10px; /* space-y-2.5 */\n  box-sizing: border-box;\n}\n\n.ccd-insights-card-header-ref {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px; /* gap-3 */\n  box-sizing: border-box;\n}\n\n.ccd-insights-card-name-ref {\n  font-size: 1.6rem;\n  font-weight: 700;\n  line-height: 1;\n  color: #0f172a; /* text-slate-950 */\n  margin: 0;\n}\n\n.ccd-insights-card-mobile-ref {\n  margin-top: 4px; /* mt-1 */\n  font-size: 13px;\n  color: #64748b; /* text-slate-500 */\n  margin-bottom: 0;\n}\n\n.ccd-insights-card-badge-ref {\n  border-radius: 9999px;\n  background-color: #eff6ff; /* bg-blue-50 */\n  padding: 4px 10px; /* px-2.5 py-1 */\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: #2a71ff;\n  white-space: nowrap;\n}\n\n.ccd-insights-card-option-ref {\n  margin-top: 12px; /* mt-3 */\n  border-radius: 18px;\n  border: 1px solid #f1f5f9; /* border-slate-100 */\n  background-color: #f8fafc; /* bg-slate-50 */\n  padding: 10px 12px; /* px-3 py-2.5 */\n  box-sizing: border-box;\n}\n\n.ccd-insights-card-option-label-ref {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: #94a3b8; /* text-slate-400 */\n  margin: 0;\n}\n\n.ccd-insights-card-option-val-ref {\n  margin-top: 6px; /* mt-1.5 */\n  font-size: 13px;\n  font-weight: 600;\n  color: #0f172a; /* text-slate-900 */\n  margin-bottom: 0;\n}\n\n.ccd-insights-grid-ref {\n  display: grid;\n  gap: 8px; /* gap-2 */\n  margin-bottom: 10px; /* space-y-2.5 */\n  box-sizing: border-box;\n}\n\n@media (min-width: 640px) {\n  .ccd-insights-grid-ref {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.ccd-insights-tile-ref {\n  border-radius: 18px;\n  border: 1px solid #ffffff;\n  background-color: #ffffff;\n  padding: 12px; /* p-3 */\n  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.06); /* shadow-[0_14px_28px_rgba(15,23,42,0.06)] */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.ccd-insights-tile-label-ref {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: #94a3b8; /* text-slate-400 */\n  margin: 0;\n}\n\n.ccd-insights-tile-val-ref {\n  margin-top: 6px; /* mt-1.5 */\n  font-size: 1.9rem;\n  font-weight: 700;\n  line-height: 1;\n  color: #0f172a; /* text-slate-950 */\n  margin-bottom: 0;\n  display: flex;\n  align-items: center;\n  gap: 6px; /* gap-1.5 */\n}\n\n.ccd-insights-last-ref {\n  border-radius: 20px;\n  border: 1px solid #e2e8f0; /* border-slate-200 */\n  background-color: rgba(255, 255, 255, 0.9); /* bg-white/90 */\n  padding: 16px; /* p-4 */\n  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.06); /* shadow-[0_14px_28px_rgba(15,23,42,0.06)] */\n  box-sizing: border-box;\n}\n\n.ccd-insights-last-label-ref {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: #94a3b8; /* text-slate-400 */\n  margin: 0;\n}\n\n.ccd-insights-last-val-ref {\n  margin-top: 6px; /* mt-1.5 */\n  font-size: 15px;\n  font-weight: 600;\n  color: #0f172a; /* text-slate-950 */\n  margin-bottom: 0;\n}\n\n.ccd-insights-empty-card-ref {\n  margin-top: 4px; /* mt-4 */\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 24px;\n  border: 1px dashed #bfdbfe; /* border-blue-200 */\n  background-color: rgba(255, 255, 255, 0.7); /* bg-white/70 */\n  padding: 24px; /* p-6 */\n  text-align: center;\n  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.04);\n  box-sizing: border-box;\n}\n\n.ccd-insights-empty-icon-ref {\n  margin-left: auto;\n  margin-right: auto;\n  display: flex;\n  height: 48px; /* h-12 */\n  width: 48px; /* w-12 */\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px; /* rounded-2xl */\n  background-color: #eff6ff; /* bg-blue-50 */\n  color: #2a71ff;\n  box-sizing: border-box;\n}\n\n.ccd-insights-empty-icon-ref svg {\n  width: 20px; /* h-5 */\n  height: 20px; /* w-5 */\n}\n\n.ccd-insights-empty-title-ref {\n  margin-top: 12px; /* mt-3 */\n  font-size: 1rem; /* text-base */\n  font-weight: 700;\n  color: #020617; /* slate-950 */\n  margin-bottom: 0;\n}\n\n.ccd-insights-empty-sub-ref {\n  margin-top: 6px; /* mt-1.5 */\n  font-size: 13px;\n  line-height: 1.25rem; /* leading-5 */\n  color: #64748b; /* text-slate-500 */\n  margin-bottom: 0;\n}\n\n.ccd-cancel-address-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #ef4444; /* red-500 */\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: color 0.2s ease;\n  padding: 0;\n  font-family: inherit;\n}\n\n.ccd-cancel-address-link:hover:not(:disabled) {\n  color: #dc2626; /* red-600 */\n}\n\n.ccd-cancel-address-link:disabled {\n  color: #fca5a5;\n  cursor: not-allowed;\n}\n\n/* ═══ DARK THEME — TakeawayDeliveryModal ═══ */\n.dark .ccd-form-side { background: #1e293b; }\n.dark .ccd-header {\n  background: linear-gradient(135deg, rgba(30,41,59,0.97), rgba(15,23,42,0.97));\n  border-bottom-color: #334155;\n}\n.dark .ccd-title { color: #f1f5f9; }\n.dark .ccd-close-btn { color: #64748b; }\n.dark .ccd-close-btn:hover { background: #334155; }\n\n.dark .ccd-section-label { color: #64748b; }\n\n.dark .ccd-option-card {\n  background: #0f172a;\n  border-color: #334155;\n  color: #94a3b8;\n}\n.dark .ccd-option-card:hover { border-color: #3b82f6; color: #60a5fa; background: #1e293b; }\n.dark .ccd-option-card--active { border-color: #0860e6 !important; color: #60a5fa !important; background: rgba(8,96,230,0.1) !important; }\n\n.dark .customer-name-new { background-color: #0f172a !important; }\n.dark .restore-text-new { color: #94a3b8; }\n\n.dark .ccd-footer { border-top-color: #334155; }\n.dark .ccd-btn-skip {\n  background: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n.dark .ccd-btn-skip:hover { background-color: #334155; border-color: #475569; }\n\n/* Insights side */\n.dark .ccd-insights-side { background: #0f172a; }\n.dark .ccd-insights-header { color: #64748b; }\n.dark .ccd-insights-customer-card {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .ccd-insights-customer-name  { color: #f1f5f9; }\n.dark .ccd-insights-customer-phone { color: #64748b; }\n.dark .ccd-insights-order-opt { border-top-color: #334155; }\n.dark .ccd-insights-opt-label { color: #64748b; }\n.dark .ccd-insights-opt-value { color: #e2e8f0; }\n.dark .ccd-insights-stat-tile {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .ccd-insights-stat-label { color: #64748b; }\n.dark .ccd-insights-stat-value { color: #f1f5f9; }\n.dark .ccd-insights-last-tile {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .ccd-insights-last-value { color: #e2e8f0; }\n.dark .ccd-insights-empty {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .ccd-insights-empty-icon { background: #1e3a8a; color: #93c5fd; }\n.dark .ccd-insights-empty-title { color: #f1f5f9; }\n.dark .ccd-insights-empty-sub  { color: #94a3b8; }\n.dark .ccd-insights-loader { color: #64748b; }\n\n/* Address cards */\n.dark .ccd-addr-card {\n  background: #0f172a;\n  border-color: #334155;\n}\n.dark .ccd-addr-card:hover { border-color: #3b82f6; background: #1e293b; }\n.dark .ccd-addr-card--active { border-color: #0860e6 !important; background: rgba(8,96,230,0.1) !important; }\n.dark .ccd-addr-type    { color: #94a3b8; }\n.dark .ccd-addr-line    { color: #cbd5e1; }\n.dark .ccd-addr-line--muted { color: #64748b; }\n.dark .ccd-delivery-address-header { color: #94a3b8; }\n\n.dark .ccd-addr-type-option {\n  background: #0f172a;\n  border-color: #334155;\n}\n.dark .ccd-addr-type-option.active { border-color: #2a71ff; background: rgba(42,113,255,0.08); }\n.dark .ccd-addr-type-label-text { color: #e2e8f0; }\n.dark .ccd-addr-radio { background: #0f172a; border-color: #475569; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
